import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKE = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M25 0C15.088 0 6.524 5.768 2.48 14.13h45.04C43.475 5.768 34.91 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 50c-9.912 0-18.476-5.768-22.52-14.13h45.04C43.475 44.232 34.91 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M48.82 17.392H1.18A24.981 24.981 0 0 0 0 25c0 2.653.415 5.21 1.18 7.609h47.64C49.584 30.209 50 27.653 50 25c0-2.653-.415-5.21-1.18-7.608Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m32.785 11.553-2.961-1.367L25 21.11l-4.824-10.923-2.96 1.367L23.203 25l-5.989 13.447 2.96 1.366L25 28.89l4.824 10.923 2.96-1.366L26.797 25l5.989-13.447Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M27.01 12.84C25.866 11.59 25 10.87 25 10.87s-.865.719-2.011 1.97V37.16c1.146 1.251 2.01 1.971 2.01 1.971s.866-.72 2.012-1.971V12.84Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M19.565 17.504v14.992c1.211 2.146 2.694 3.905 3.804 5.07V12.434c-1.11 1.166-2.593 2.925-3.804 5.071ZM30.434 17.504c-1.21-2.146-2.693-3.905-3.804-5.07v25.133c1.111-1.166 2.593-2.925 3.805-5.071V17.504Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M30.435 17.504v14.992c1.226-2.173 2.174-4.742 2.174-7.496 0-2.753-.948-5.323-2.174-7.496ZM19.565 17.504v14.992c-1.226-2.173-2.174-4.742-2.174-7.496 0-2.753.948-5.323 2.174-7.496Z"
}));
FlagKE.displayName = 'FlagKE';
export default withFlagWrapper(FlagKE);
//# sourceMappingURL=index.js.map